import { StructuredQuery } from '../../../core/query/entities/structured-query.entity';
import { UrlQueryState } from '../entities/search-page-state.entity';

export function isUrlQueryStateEmpty(urlQueryState: UrlQueryState): boolean {
    const structuredQueryEmpty = isStructuredQueryEmpty(urlQueryState.structuredQuery);
    const selectedFacetsEmpty = urlQueryState.selectedFacets.length === 0;
    const pageEmpty = urlQueryState.page === 0;
    const pageSizeEmpty = urlQueryState.pageSize === undefined;
    const sortInfoEmpty = urlQueryState.sortInfo === undefined;
    const viewEmpty = urlQueryState.view === undefined;

    return structuredQueryEmpty && selectedFacetsEmpty && pageEmpty && pageSizeEmpty && sortInfoEmpty && viewEmpty;
}

export function isStructuredQueryEmpty(structuredQuery: StructuredQuery): boolean {
    const emptyGlobal: boolean = structuredQuery.Global.every(g => g === '');
    const emptyAdv: boolean = structuredQuery.AdvancedSearch.Groups.flatMap(group => group.Terms ?? []).every(
        term => term.Values?.length === 0
    );
    const emptySemantic: boolean = !structuredQuery.Semantic;
    const emptyFullText: boolean = !structuredQuery.FullText;
    const emptyFacets: boolean = structuredQuery.Facets.every(
        f => f.Buckets?.length === 0 && f.RangeBuckets?.length === 0
    );
    const emptyFields: boolean = structuredQuery.Fields.length === 0;

    return emptyGlobal && emptyAdv && emptyFacets && emptyFields && emptySemantic && emptyFullText;
}
